import {Col, Row} from "react-bootstrap";
import Footer from "./footer";
import NavBar from "./navbar";

export default function AboutComponent() {
    return (
        <Col style={{padding:0}}>
            <NavBar/>
            <div style={{padding: "5% 10%", fontFamily: "Circular Std Book, sans-serif"}}>
                <Row className="title-text"
                     style={{fontSize: "23px", fontWeight: "200", display: "flex", justifyContent: "center"}}>О проекте
                    Маск Эскорт</Row>
                <Row className="text"
                     style={{marginTop: "25px", backgroundColor: "#181A26", padding: "20px 20px", fontSize: "14px"}}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div style={{color: "white", fontSize: "16px"}}>Маск Эскорт</div>
                        эксклюзивный агрегатор в мире интим-услуг
                        виртуальная площадка с анкетами элитных дам, предоставляющих платный интим. Здесь можно найти
                        проститутку-индивидуалку на любой вкус: жрицу любви, нежную спутницу на час, леди для
                        сопровождения вечеринки. Интересный досуг с нашими дамами гарантирован.
                    </div>
                    <div style={{marginTop: "20px"}}>
                        Почему доверяют Маск Эскорт
                        Агрегатор сексуальных услуг предоставляет:
                    </div>
                    <div style={{marginTop: "20px"}}>
                        Более тысячи реальных анкет проституток, каждый день их число растет;
                        ручную проверку анкет девушек, фотографий и телефонных номеров;
                        гарантию конфиденциальности и анонимности каждого обращения;
                        лояльные условия сотрудничества.
                        Факты, которыми гордимся 😎:
                        Более 30 000 пользователей ежедневно посещают портал;
                        отображаем честную Яндекс-Метрику;
                        являемся лидером по просмотрам и среднему времени сессии;
                        Являемся ТОП-1 интим-агрегатором по количеству суточного трафика;
                        имеем свою сеть телеграм-каналов и ботов, где уже более 620К подписчиков, 95К из них —
                        постоянные клиенты
                    </div>
                    <div style={{marginTop: "20px"}}>
                        Макс эскорт удовольствия больше, чем платишь!
                        Площадка рассчитана на аудиторию 18+ и закрывает разные вкусовые предпочтения клиентов.
                        Юзабилити настолько удобно, что для заказа проститутки понадобится минимум сил и времени.
                        Достаточно позвонить по указанному номеру, и вечер блаженства будет обеспечен. Бывалые могут
                        оставить отзыв под анкетой.
                    </div>
                </Row>
            </div>
            <Footer/>
        </Col>
    )
}